var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toggle__Action Type=Toggle, State=Enabled, Size=24",
    className: "toggle__Action toggle__Type=Toggle, toggle__State=Enabled, toggle__Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toggle__Vector",
    className: "toggle__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454F5B",
    d: "M11.698 12a3.209 3.209 0 1 1-6.418 0 3.209 3.209 0 0 1 6.418 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454F5B",
    d: "M20.148 12a4.539 4.539 0 0 0-4.538-4.54H8.39a4.539 4.539 0 0 0 0 9.078h7.22A4.539 4.539 0 0 0 20.148 12Zm1.352 0a5.89 5.89 0 0 1-5.89 5.89H8.39a5.89 5.89 0 0 1 0-11.78h7.22A5.89 5.89 0 0 1 21.5 12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.3be950d14bf375fd927cbe936d169ffe.svg";
export { ForwardRef as ReactComponent };